import { FETCH_CHARGER_LOG, DELETE_CHARGER_LOG } from 'actions/activityLog';

const initialState = {
  isLoading: false,
  activityLogs: [],
  page: 1,
  limit: 10,
  totalPages: 1,
  total: 1,
};

const activityLogReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case FETCH_CHARGER_LOG.REQUEST:
    case DELETE_CHARGER_LOG.REQUEST: {
      return { ...state, isLoading: true };
    }
    case FETCH_CHARGER_LOG.SUCCESS: {
      return {
        ...state,
        isLoading: false,
        activityLogs: payload.results,
        page: payload.page,
        limit: payload.limit,
        totalPages: payload.totalPages,
        total: payload.totalResults,
      };
    }
    case DELETE_CHARGER_LOG.SUCCESS: {
      return {
        ...state,
        activityLogs: state.activityLogs.filter((data) => data.id !== payload),
      };
    }

    case FETCH_CHARGER_LOG.FAIL:
    case DELETE_CHARGER_LOG.FAIL: {
      return {
        ...state,
        isLoading: false,
      };
    }
    default:
      return { ...state };
  }
};
export default activityLogReducer;
